/**
 * @fileoverview POST handler for the "/app_groups/:app_group_id/placements/update_archived_state" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { appGroupsAppGroupIdPlacementsUpdateArchivedStateCacheKeys } from "./constants";
import type {
  PostAppGroupsAppGroupIdPlacementsUpdateArchivedStateProps,
  PostAppGroupsAppGroupIdPlacementsUpdateArchivedStateResult,
} from "./types";

export const postAppGroupsAppGroupIdPlacementsUpdateArchivedState = reactQueryMutationAdapter(
  appGroupsAppGroupIdPlacementsUpdateArchivedStateCacheKeys,
  ({
    ids,
    appGroupId,
    mark_as_archived,
  }: PostAppGroupsAppGroupIdPlacementsUpdateArchivedStateProps): Promise<PostAppGroupsAppGroupIdPlacementsUpdateArchivedStateResult> => {
    return fetch(
      `/app_groups/${appGroupId}/placements/update_archived_state`,
      "POST",
      { ids, marked_as_deleted: mark_as_archived },
      undefined,
      {
        // don't display a modal on fetch errors
        propagateFetchRequestError: false,
      }
    );
  }
);
